import { Component, OnInit, OnDestroy, Renderer2, ViewChildren, QueryList, AfterContentInit } from "@angular/core";
import { FirebaseService } from "../../providers/firebase.service";
import { ActivatedRoute, Router } from "@angular/router";
import { isNullOrUndefined, isUndefined } from "util";
import { Client } from "../../models/client";
import { PageSettings } from "../../models/pageSettings";
import { ComponentSettings } from "../../models/componentSettings";
import { ClientSettings } from "../../models/client-settings";
import {
  InfoBarStyleOptions,
  LocationBarStyleOptions
} from "../../models/client-settings-options";
import { ScrollService } from "../../providers/scroll.service";
import { MdSlideToggleChange } from "@angular/material";
import { LocationHome } from "../../models/location-home";
import { ComponentStructureComponent } from '../../components/component-structure/component-structure.component';
import { BehaviorSubject } from 'rxjs';

declare const swal: any;

@Component({
  selector: "app-component-structure-settings",
  templateUrl: "./component-structure-settings.component.html",
  styleUrls: ["./component-structure-settings.component.css"]
})
export class ComponentStructureSettingsComponent implements OnInit, AfterContentInit, OnDestroy {
  key: string;
  removeListener;
  clientData: Client;
  clientDataSettings: ClientSettings;
  pageSettings: PageSettings;
  componentSettings: ComponentSettings;

  infoBarStyleOptions = InfoBarStyleOptions;
  locationBarStyleOptions = LocationBarStyleOptions;

  alreadyCheckBilly = false;
  goodToGo = [false, false, false];
  checkLoaded = new BehaviorSubject<boolean>(false);

  @ViewChildren(ComponentStructureComponent) styleSettings: QueryList<ComponentStructureComponent>

  headerType = [
    { label: "Insights Hero", value: "insights" },
    { label: "Video Slider", value: "video" },
    { label: "Picture Slider", value: "slider" },
    { label: "Simple Slider with Locations Button", value: "simple" },
    { label: "Simple Video with Locations Button", value: "simple-video" },
    { label: "Big Title", value: "big-title" },
    { label: "Big Buttons", value: "big-buttons" }
  ];

  locationHomeHeaderType = [
    { label: "None", value: "none" },
    { label: "Insights Hero", value: "insights" },
    { label: "Simple Slider", value: "simple" },
    { label: "Simple Video", value: "simple-video" },
  ];

  locationSlideout = [
    { label: "None", value: "none" },
    { label: "Original", value: "original" }
  ];

  navBarLocationOptions = [
    { label: "Above Main Nav", value: "top" },
    { label: "Below Main Nav", value: "bottom" }
  ];

  simpleHeroTabBoxOptions = [
    { label: "Original", value: "original" },
    { label: "Original V2", value: "originalV2" }
  ];

  googleMapComponentLocationOptions = [
    { label: "Show Above Secondary Icons/ Button CTA", value: "aboveSecondaryIcons" },
    { label: "Bottom Of page, above the Footer", value: "aboveFooter" },
    { label: "Just Below Separator Bar", value: "belowSeparator" }
  ];

  mainNavBarOptions = [
    /*     { label: "Original", value: "original" }, */
    { label: "Sticky Original", value: "stickyOriginal" },
    /*     { label: "Nav with Pay Bill", value: "navWithPayBill" }, */
    { label: "Sticky Nav with Pay Bill", value: "stickyNavWithPayBill" },
    /*     { label: "Nav with Pay Bill Centered", value: "navWithPayBillCentered" },
        { label: "Sticky Nav with Pay Bill Centered", value: "stickyNavWithPayBillCentered" },
        { label: "Sticky Transparent Nav with Pay Bill", value: "stickyTransparentNavWithPayBill" } */
  ];

  homePageButtonComponent = [
    { label: "Original", value: "original" },
    { label: "With Picture", value: "withPicture" },
    { label: "None", value: "none" }
  ];

  homePageFeaturesComponent = [
    { label: "SVGs", value: "svg" },
    { label: "Original", value: "original" },
    { label: "Original w/ Outer Circle", value: "originalWithOuterCircle" },
    { label: "None", value: "none" }
  ];

  viewAllUnitsComponent = [
    { label: "Original", value: "original" },
    { label: "Modern", value: "modern" },
    { label: "Text Only", value: "textOnly" },
    { label: "Version 3", value: "version3" },
    { label: "None", value: "none" },
  ];

  viewAllUnitsComponentHeaderType = [
    { label: "Location Box", value: "locationBox" },
    { label: "Location Box v2 (Full)", value: "locationBoxV2" },
    { label: "Location Box v3", value: "locationBoxV3" },
    { label: "None", value: "none" },
  ];

  comingSoonComponent = [
    { label: "Original", value: "original" },
    { label: "None", value: "none" },
  ];

  homePageFindUsComponent = [
    { label: "Original", value: "original" },
    { label: "None", value: "none" }
  ];

  homePageFeaturesComponentLocation = [
    { label: "Below CTA Bar", value: "belowCTA" },
    { label: "Above CTA", value: "aboveCTA" }
  ];

  homePageMainIconsComponent = [
    { label: "Svg", value: "svg" },
    { label: "Original", value: "original" },
    { label: "With Boxes", value: "withBoxes" },
    { label: "V3", value: "v3" },
    { label: "None", value: "none" }
  ];

  aboutUsHero = [
    { label: "Original", value: "original" },
    { label: "None", value: "none" }
  ];

  customPageHero = [
    { label: "Original", value: "original" },
    { label: "None", value: "none" }
  ];

  contactHeader = [
    { label: "None", value: "none" },
    { label: "Original", value: "original" }
  ];

  generalInfoHeader = [
    { label: "Original", value: "original" },
    { label: "None", value: "none" }
  ];

  generalInfoMainSection = [
    { label: "Original", value: "original" },
    { label: "None", value: "none" }
  ];

  faqsHeader = [
    { label: "Original", value: "original" },
    { label: "None", value: "none" }
  ];

  faqsMainSection = [
    { label: "Original", value: "original" },
    { label: "None", value: "none" }
  ];

  viewAllReviewsHeader = [
    { label: "None", value: "none" },
    { label: "Original", value: "original" }
  ];

  storeLocatorHeader = [
    { label: "Original", value: "original" },
    { label: "None", value: "none" }
  ];

  storageCalculatorHeader = [
    { label: "Original", value: "original" },
    { label: "None", value: "none" }
  ];

  storageCalculatorBody = [
    { label: "None", value: "none" },
    { label: "Version 1", value: "v1" }
  ];

  storageTipsHeader = [
    { label: "Original", value: "original" },
    { label: "None", value: "none" }
  ];

  storageTipsBody = [
    { label: "Cards With Dropdowns", value: "cards" },
    { label: "Original", value: "original" },
    { label: "With Dropdowns", value: "dropdowns" },
    { label: "None", value: "none" }
  ];

  aboutUsMainSection = [
    { label: "Original", value: "original" },
    { label: "Rows", value: "rows" },
    { label: "Custom HTML", value: "html" },
    { label: "None", value: "none" }
  ];

  sizeGuideHero = [
    { label: "Original", value: "original" },
    { label: "None", value: "none" }
  ];

  sizeGuideMainSection = [
    { label: "Original", value: "original" },
    { label: "Version 2", value: "version2" },
    { label: "None", value: "none" }
  ];

  contactForm = [
    { label: "Float Over Map", value: "floatOverMap" },
    { label: "Original", value: "original" },
    { label: "Original v2", value: "originalV2" },
    { label: "None", value: "none" }
  ];

  locationBannerComponent = [
    { label: "Original", value: "original" },
    { label: "By State", value: "state" },
    { label: "Insights", value: "insights" },
    { label: "None", value: "none" }
  ];

  facilityInfoBannerComponent = [
    { label: "Original", value: "original" },
    { label: "Version 2", value: "version2" },
    { label: "None", value: "none" }
  ];

  slideshowRowComponent = [
    { label: "Original", value: "original" },
    { label: "None", value: "none" }
  ];

  howToRowComponent = [
    { label: "Original", value: "original" },
    { label: "None", value: "none" }
  ];

  uhaulDealerBannerComponent = [
    { label: "Original", value: "original" },
    { label: "None", value: "none" }
  ];

  htmlRowComponent = [
    { label: "None", value: "none" },
    { label: "Original", value: "original" },
  ];

  portableQuoteBarComponent = [
    { label: "Original", value: "original" },
    { label: "None", value: "none" }
  ];

  separatorBarComponent = [
    { label: "Original", value: "original" },
    { label: "None", value: "none" }
  ];

  locationSeparatorBarComponent = [
    { label: "Original", value: "original" }
  ];

  locationHomeViewAllUnitsComponent = [
    { label: "Original", value: "original" },
    { label: "None", value: "none" }
  ];

  locationsNearYouBannerComponent = [
    { label: "None", value: "none" },
    { label: "Original", value: "original" }
  ];

  footer = [
    { label: "Original", value: "original" },
    { label: "With Form", value: "withForm" },
    { label: "Small", value: "small" },
    { label: "None", value: "none" }
  ];

  associations = [
    { label: "Original", value: "original" },
    { label: "None", value: "none" }
  ];

  switchLocationComponent = [
    { label: "Original", value: "original" },
    { label: "Cards", value: "cards" },
    { label: "With Rent a Unit", value: "units" },
    { label: "Original with Map", value: "map" },
    { label: "Locations by States", value: "states" },
    { label: "None", value: "none" },
  ];

  portalLoginComponent = [
    { label: "Original", value: "original" },
    { label: "Simple", value: "simple" },
    { label: "With Background Image", value: "withImage" },
    { label: "None", value: "none" }
  ];

  googleMapComponent = [
    { label: "Original", value: "original" },
    { label: "None", value: "none" }
  ];

  storeLocatorComponent = [
    { label: "Original", value: "original" },
    { label: "None", value: "none" }
  ];


  constructor(
    public afService: FirebaseService,
    private route: ActivatedRoute,
    private router: Router,
    private scroll: ScrollService,
    private renderer: Renderer2
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.key = params["key"];
      this.afService.getClientInfo(this.key).subscribe(clientData => {
        this.clientData = clientData;
        let shouldUpdate = false;
        if (isNullOrUndefined(this.clientData.infoBarStyle)) {
          this.clientData.infoBarStyle = "original";
          shouldUpdate = true;
        }

        if (isNullOrUndefined(this.clientData.locationBarStyle)) {
          this.clientData.locationBarStyle = "original";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.mainNavBar)) {
          this.clientData.mainNavBar = "original";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.locationHomeViewAllUnitsComponent)) {
          this.clientData.locationHomeViewAllUnitsComponent = "original";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.portableQuoteBarComponent)) {
          this.clientData.portableQuoteBarComponent = "original";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.locationSeparatorBarComponent)) {
          this.clientData.locationSeparatorBarComponent = "original";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.htmlRowComponent)) {
          this.clientData.htmlRowComponent = "original";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.homePageButtonComponent)) {
          this.clientData.homePageButtonComponent = "original";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.homePageFindUsComponent)) {
          this.clientData.homePageFindUsComponent = "original";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.homePageFeaturesComponent)) {
          this.clientData.homePageFeaturesComponent = "svg";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.locationSlideout)) {
          this.clientData.locationSlideout = "none";
          shouldUpdate = true;
        }
        if (
          isNullOrUndefined(this.clientData.homePageFeaturesComponentLocation)
        ) {
          this.clientData.homePageFeaturesComponentLocation = "belowCTA";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.homePageMainIconsComponent)) {
          this.clientData.homePageMainIconsComponent = "v3";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.aboutUsHero)) {
          this.clientData.aboutUsHero = "original";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.customPageHero)) {
          this.clientData.customPageHero = "original";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.aboutUsMainSection)) {
          this.clientData.aboutUsMainSection = "original";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.googleMapComponentLocation)) {
          this.clientData.googleMapComponentLocation = "aboveFooter";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.sizeGuideHero)) {
          this.clientData.sizeGuideHero = "original";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.sizeGuideMainSection)) {
          this.clientData.sizeGuideMainSection = "version2";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.contactForm)) {
          this.clientData.contactForm = "floatOverMap";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.footer)) {
          this.clientData.footer = "original";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.associations)) {
          this.clientData.associations = "none";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.switchLocationComponent)) {
          this.clientData.switchLocationComponent = "original";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.portalLoginComponent)) {
          this.clientData.portalLoginComponent = "simple";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.viewAllUnitsComponentHeaderType)) {
          this.clientData.viewAllUnitsComponentHeaderType = "locationBoxV2";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.viewAllUnitsComponent)) {
          this.clientData.viewAllUnitsComponent = "modern";
          shouldUpdate = true;
        }
        if (this.clientData.viewAllUnitsComponent == 'version3') {
          this.clientData.viewAllUnitsComponentHeaderType = "locationBoxV3";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.comingSoonComponent)) {
          this.clientData.comingSoonComponent = "original";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.googleMapComponent)) {
          this.clientData.googleMapComponent = "original";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.storeLocatorComponent)) {
          this.clientData.storeLocatorComponent = "none";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.locationBannerComponent)) {
          this.clientData.locationBannerComponent = "none";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.facilityInfoBannerComponent)) {
          this.clientData.facilityInfoBannerComponent = "none";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.uhaulDealerBannerComponent)) {
          this.clientData.uhaulDealerBannerComponent = "none";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.locationsNearYouBannerComponent)) {
          this.clientData.locationsNearYouBannerComponent = "none";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.slideshowRowComponent)) {
          this.clientData.slideshowRowComponent = "none";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.howToRowComponent)) {
          this.clientData.howToRowComponent = "none";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.storageTipsHeader)) {
          this.clientData.storageTipsHeader = "none";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.storeLocatorHeader)) {
          this.clientData.storeLocatorHeader = "none";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.storageCalculatorHeader)) {
          this.clientData.storageCalculatorHeader = "none";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.storageCalculatorBody)) {
          this.clientData.storageCalculatorBody = "none";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.viewAllReviewsHeader)) {
          this.clientData.viewAllReviewsHeader = "none";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.storageTipsBody)) {
          this.clientData.storageTipsBody = "none";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.contactHeader)) {
          this.clientData.contactHeader = "none";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.generalInfoHeader)) {
          this.clientData.generalInfoHeader = "none";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.generalInfoMainSection)) {
          this.clientData.generalInfoMainSection = "none";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.faqsHeader)) {
          this.clientData.faqsHeader = "none";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.faqsMainSection)) {
          this.clientData.faqsMainSection = "none";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.contactFormData)) {
          this.clientData.contactFormData = {
            phoneAddressFontSize: '',
            subtitleFontSize: '',
            showLocationName: false,
            contactCtaBlurb: 'Thanks for taking the time to reach out to us. We look forward to helping in any way we can!',
            showPhoneNumber: true,
            showUnitNumber: false,
            windowBorderRadius: '10px',
            windowPlacement: 'right'
          };
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.portalNavbarData)) {
          this.clientData.portalNavbarData = {
            height: "45px",
            fontSize: "20px",
            padding: "8px 12px 8px 12px",
            mattStyle: false,
          };
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.aboutUsHeroData)) {
          this.clientData.aboutUsHeroData = {
            useCard: false,
            cardBackground: '#FFF',
            cardBorderRadius: '0px',
            cardPadding: '34px',
            height: '200px',
            background: 'linear-gradient(rgba(0,0,0,.35),rgba(0,0,0,.35)), url(https://firebasestorage.googleapis.com/v0/b/prod-rocky-hill-storage.appspot.com/o/frame-100180.jpg?alt=media&token=aef8866f-a7fb-4f23-8fe7-921c7bb5aac7) center no-repeat',
            backgroundSize: 'cover',
            fontWeight: '700',
            color: '#fff',
            title: '',
            subtitle: ''
          };
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.aboutUsMainSectionData)) {
          this.clientData.aboutUsMainSectionData = {
            useSlider: false
          }
        };
        if (isNullOrUndefined(this.clientData.customPageHeroData)) {
          this.clientData.customPageHeroData = {
            useCard: false,
            cardBackground: '#FFF',
            cardBorderRadius: '0px',
            cardPadding: '34px',
            height: '200px',
            background: 'linear-gradient(rgba(0,0,0,.35),rgba(0,0,0,.35)), url(https://firebasestorage.googleapis.com/v0/b/prod-rocky-hill-storage.appspot.com/o/frame-100180.jpg?alt=media&token=aef8866f-a7fb-4f23-8fe7-921c7bb5aac7) center no-repeat',
            backgroundSize: 'cover',
            fontWeight: '700',
            color: '#FFF',
          };
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.locationHomeViewAllUnitsData)) {
          this.clientData.locationHomeViewAllUnitsData = {
            lazyLoadUnits: false,
            small: false,
            showFacilityName: false,
            initialSortSize: "sm",
            titleText: "Available Storage Units",
            showTitleShading: false,
            breakPoint: "sm",
            titleFontSize: '',
            titleMargin: '30px 0',
            titleTextAlign: 'center',
            titleColor: '',
            smallSettingsFilterTitleFullText: false,
            smallSettingsShowFilterIcons: false,
            wrapperBg: '#fff',
            wrapperPaddingBottom: '50px',
            filterChipColor: '#fff',
            filterChipBg: 'rgb(244, 189, 40)',
            filterChipThreshold: -1,
            filterBackground: '#efefef',
            filterIconFontSize: '',
            filterShowIcons: true,
            amenitiesIconWidth: '40px',
            amenitiesType: 'icon',
            amenitiesIconMargin: '5px 5px 0 0',
            priceShowBorder: false,
            priceFontSize: '',
            priceOldRateColor: '',
            priceOldRateFontSize: '',
            priceDiscountFontSize: '',
            showLocationInfoMapCard: false,
          };
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.viewAllReviewsHeaderData)) {
          this.clientData.viewAllReviewsHeaderData = {
            useCard: false,
            cardBackground: '#FFF',
            cardBorderRadius: '0px',
            cardPadding: '34px',
            height: '200px',
            background: 'linear-gradient(rgba(0,0,0,.35),rgba(0,0,0,.35)), url(https://firebasestorage.googleapis.com/v0/b/prod-rocky-hill-storage.appspot.com/o/frame-100180.jpg?alt=media&token=aef8866f-a7fb-4f23-8fe7-921c7bb5aac7) center no-repeat',
            backgroundSize: 'cover',
            fontWeight: '700',
            color: '#FFF'
          };
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.storageTipsHeaderData)) {
          this.clientData.storageTipsHeaderData = {
            useCard: false,
            cardBackground: '#FFF',
            cardBorderRadius: '0px',
            cardPadding: '34px',
            height: '200px',
            background: 'linear-gradient(rgba(0,0,0,.35),rgba(0,0,0,.35)), url(https://firebasestorage.googleapis.com/v0/b/prod-rocky-hill-storage.appspot.com/o/frame-100180.jpg?alt=media&token=aef8866f-a7fb-4f23-8fe7-921c7bb5aac7) center no-repeat',
            backgroundSize: 'cover',
            fontWeight: '700',
            color: '#FFF',
            title: '',
            subtitle: ''
          };
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.storeLocatorHeaderData)) {
          this.clientData.storeLocatorHeaderData = {
            useCard: false,
            cardBackground: '#FFF',
            cardBorderRadius: '0px',
            cardPadding: '34px',
            height: '200px',
            background: 'linear-gradient(rgba(0,0,0,.35),rgba(0,0,0,.35)), url(https://firebasestorage.googleapis.com/v0/b/prod-rocky-hill-storage.appspot.com/o/frame-100180.jpg?alt=media&token=aef8866f-a7fb-4f23-8fe7-921c7bb5aac7) center no-repeat',
            backgroundSize: 'cover',
            fontWeight: '700',
            color: '#FFF',
            title: ''
          };
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.storageCalculatorHeaderData)) {
          this.clientData.storageCalculatorHeaderData = {
            useCard: false,
            cardBackground: '#FFF',
            cardBorderRadius: '0px',
            cardPadding: '34px',
            height: '200px',
            background: 'linear-gradient(rgba(0,0,0,.35),rgba(0,0,0,.35)), url(https://firebasestorage.googleapis.com/v0/b/prod-rocky-hill-storage.appspot.com/o/frame-100180.jpg?alt=media&token=aef8866f-a7fb-4f23-8fe7-921c7bb5aac7) center no-repeat',
            backgroundSize: 'cover',
            fontWeight: '700',
            color: '#FFF',
            title: '',
            subtitle: ''
          };
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.storageCalculatorBodyData)) {
          this.clientData.storageCalculatorBodyData = {};
        }
        if (isNullOrUndefined(this.clientData.viewAllUnitsComponentHeaderTypeData)) {
          this.clientData.viewAllUnitsComponentHeaderTypeData = {
            sidebar: 'show',
            background: 'linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url("https://cdn.storagepug.com/hubfs/Client%20Website%20Images/All/AdobeStock_273706852.jpeg") no-repeat',
            height: '',
          };
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.storageTipsBodyData)) {
          this.clientData.storageTipsBodyData = {
            showTipsBlurb: false,
            blurbTipsPlacement: ''
          };
        }
        if (isNullOrUndefined(this.clientData.contactHeaderData)) {
          this.clientData.contactHeaderData = {
            useCard: false,
            cardBackground: '#FFF',
            cardBorderRadius: '0px',
            cardPadding: '34px',
            height: '200px',
            background: 'linear-gradient(rgba(0,0,0,.35),rgba(0,0,0,.35)), url(https://firebasestorage.googleapis.com/v0/b/prod-rocky-hill-storage.appspot.com/o/frame-100180.jpg?alt=media&token=aef8866f-a7fb-4f23-8fe7-921c7bb5aac7) center no-repeat',
            backgroundSize: 'cover',
            fontWeight: '700',
            color: '#FFF',
            title: ''
          };
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.generalInfoHeaderData)) {
          this.clientData.generalInfoHeaderData = {
            useCard: false,
            cardBackground: '#FFF',
            cardBorderRadius: '0px',
            cardPadding: '34px',
            height: '200px',
            background: 'linear-gradient(rgba(0,0,0,.35),rgba(0,0,0,.35)), url(https://firebasestorage.googleapis.com/v0/b/prod-rocky-hill-storage.appspot.com/o/frame-100180.jpg?alt=media&token=aef8866f-a7fb-4f23-8fe7-921c7bb5aac7) center no-repeat',
            backgroundSize: 'cover',
            fontWeight: '700',
            color: '#FFF',
            title: ''
          };
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.generalInfoMainSectionData)) {
          this.clientData.generalInfoMainSectionData = {};
        }
        if (isNullOrUndefined(this.clientData.faqsHeaderData)) {
          this.clientData.faqsHeaderData = {
            useCard: false,
            cardBackground: '#FFF',
            cardBorderRadius: '0px',
            cardPadding: '34px',
            height: '200px',
            background: 'linear-gradient(rgba(0,0,0,.35),rgba(0,0,0,.35)), url(https://firebasestorage.googleapis.com/v0/b/prod-rocky-hill-storage.appspot.com/o/frame-100180.jpg?alt=media&token=aef8866f-a7fb-4f23-8fe7-921c7bb5aac7) center no-repeat',
            backgroundSize: 'cover',
            fontWeight: '700',
            color: '#FFF',
            title: ''
          };
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.faqsMainSectionData)) {
          this.clientData.faqsMainSectionData = {
            fontSize: '',
            titleFontSize: '',
            titleColor: '',
            selectedTitleColor: '',
            selectedTitleBackgroundColor: '',
            showBlurb: true,
            blurbPlacement: 'left',
          };
        }
        if (isNullOrUndefined(this.clientData.locationSlideoutData)) {
          this.clientData.locationSlideoutData = {
            titleBackground: '#3D73B9',
            titleColor: '#fff',
            titleFontSize: '20px',
            locationTitleColor: '#3D73B9',
            locationTitleSize: '20px',
            locationFontColor: '#000',
            locationFontSize: '14dpx',
            locationLinkColor: '#3D73B9',
            heightFromTop: '250px',
            innerHeightFromTop: '250px',
            innerHeight: '330px',
            titleHeight: '170px',
            titleBorderRadius: '0 5px 5px 0',
            innerWidth: '500px',
            border: '1px solid #3D73B9',
            titleText: 'Location Info',
            leftButtonText: 'Corporate Home',
            rightButtonText: 'Switch Location',
            locationButtonBackground: '#3D73B9',
            isRightSide: false,
            useMapComponentInstead: false
          };
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.homePageFindUsComponentData)) {
          this.clientData.homePageFindUsComponentData = {
            background: "rgba(255, 255, 255, 0)",
            color: "",
            height: "145px",
            title: '',
            subtitle: ''
          };
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.portalLoginData.logoWidth)) {
          this.clientData.portalLoginData.logoWidth = '130px';
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.homePageMainIconsComponentData)) {
          this.clientData.homePageMainIconsComponentData = {
            background: "",
            boxBackground: "#fff",
            color: "",
            featureIconBackgroundColor: "",
            featureIconColor: "",
            showBoxShadow: true,
            showBoxes: true,
            showMaterialDesignShading: true,
            size: "55px",
            textFontSize: "",
            titleFontSize: "",
          };
          shouldUpdate = true;
        }

        if (isNullOrUndefined(this.clientData.viewAllUnitsComponentData)) {
          this.clientData.viewAllUnitsComponentData = {
            border: "2px solid #6689FF",
            catButtonsBackground: "",
            catButtonsColor: "",
            rentButtonBackground: "",
            rentButtonColor: "",
            reserveButtonBackground: "",
            reserveButtonColor: "",
            viewUnitsChipBackground: "",
            viewUnitsChipColor: "",
            discountColor: "",
            rentUnitFontSize: "",
            reserveUnitFontSize: "",
            ctaText: "Reserve Your Unit Today!",
            spaceInsteadOfUnit: false,
            lazyLoadUnits: false,
            small: false,
            initialSortSize: "",
            titleText: "Available Storage Units",
            breakPoint: "sm",
            titleFontSize: '',
            titleMargin: '30px 0',
            titleTextAlign: 'center',
            titleColor: '',
            smallSettingsFilterTitleFullText: false,
            smallSettingsShowFilterIcons: false,
            wrapperBg: '',
            wrapperPaddingBottom: '50px',
            filterChipColor: '',
            filterChipBg: '',
            filterChipThreshold: 5,
            filterBackground: '',
            filterIconFontSize: '',
            filterShowIcons: true,
            amenitiesIconWidth: '50px',
            amenitiesType: 'icon',
            amenitiesIconMargin: '5px 5px 0 0',
            priceShowBorder: false,
            priceFontSize: '',
            priceOldRateColor: '',
            priceOldRateFontSize: '',
            priceDiscountFontSize: '',
            checkoutSidebarColor: ''
          };
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.comingSoonComponentData)) {
          this.clientData.comingSoonComponentData = {
            backgroundColor: "#33475b",
          };
          shouldUpdate = true;
        }


        if (isNullOrUndefined(this.clientData.viewAllUnitsComponentData.lazyLoadUnits)) {
          this.clientData.viewAllUnitsComponentData.lazyLoadUnits = false;
          this.clientData.viewAllUnitsComponentData.priceShowBorder = false;
          this.clientData.viewAllUnitsComponentData.smallSettingsFilterTitleFullText = false;
          this.clientData.viewAllUnitsComponentData.smallSettingsShowFilterIcons = false;
          this.clientData.viewAllUnitsComponentData.small = false;
          shouldUpdate = true;
        }

        if (isNullOrUndefined(this.clientData.tabBoxData)) {
          this.clientData.tabBoxData = {
            width: "400px",
            color: "#636973",
            mobileColor: "#636973",
            tabLabelColor: "#636973",
            mobileTabLabelColor: "#636973",
            titleSize: "1.37em",
            titleColor: "#636973",
            background: "hsla(0,0%,100%,.8)",
            borderRadius: "10px",
            left: "5%",
            top: "10%",
            minHeight: "431px",
            buttonWidth: "90%",
            buttonFontSize: "1.6em",
            padding: "0px 25px 25px 25px",
            buttonPadding: "15px",
            buttonMarginTop: "15px",
            buttonBackground: "#6689FF",
            buttonColor: "#fff",
            phoneLinkColor: "#6689FF",
            taglineFontStyle: "",
            showLocationName: false,
            showEmail: false,
            corporateHeroHeight: '525px',
            locationHeroHeight: '525px',
            locationShowImagesOnV2: false
          };
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.locationTabBoxData)) {
          this.clientData.locationTabBoxData = {
            width: "400px",
            color: "#636973",
            mobileColor: "#636973",
            tabLabelColor: "#636973",
            mobileTabLabelColor: "#636973",
            titleSize: "1.37em",
            titleColor: "#636973",
            background: "hsla(0,0%,100%,.8)",
            borderRadius: "10px",
            left: "5%",
            top: "10%",
            minHeight: "431px",
            buttonWidth: "90%",
            buttonFontSize: "1.6em",
            padding: "0px 25px 25px 25px",
            buttonPadding: "15px",
            buttonMarginTop: "15px",
            buttonBackground: "#6689FF",
            buttonColor: "#fff",
            phoneLinkColor: "#6689FF",
            taglineFontStyle: "",
            showLocationName: false,
            showEmail: false,
            corporateHeroHeight: '525px',
            locationHeroHeight: '525px',
            locationShowImagesOnV2: false
          };
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.bigTitleData)) {
          this.clientData.bigTitleData = {
            titleSize: "4em",
            titleWeight: "600",
            titleColor: "#636973",
            titleShadow: "0px 4px 6px #000000",
            titleMargin: "20% auto 5px auto",
            background: "transparent",
            minHeight: "431px",
            buttonWidth: "20%",
            buttonMaxWidth: "215px",
            buttonFontSize: "1.6em",
            padding: "0px 25px 25px 25px",
            buttonPadding: "15px",
            buttonMargin: "15px",
            buttonBackground: "#6689FF",
            buttonColor: "#fff",
            phoneLinkColor: "#6689FF"
          };
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.footerData)) {
          this.clientData.footerData = {
            background: "#33475B",
            trademarkBackground: "#2A3B4B",
            height: "200px",
            trademarkHeight: "50px",
            trademarkColor: "#636973",
            color: "#E0E0E0",
            phoneFontSize: "",
            titleFontSize: "",
            linkColor: "#fff",
            showDropdownLinks: true,
            showBottomText: false,
            showFacilityNameAndLocation: false,
            bottomText: "",
            subheading: '',
            altLogoUrl: '',
          };
          shouldUpdate = true;
        }


        if (isNullOrUndefined(this.clientData.locationsNearYouBannerData)) {
          this.clientData.locationsNearYouBannerData = {
            background: '#37474F',
            cardColor: '#37474F',
            closestStoreRibbonColor: '#37474F',
            closestStoreRibbonBackgroundColor: '#FFF',
            color: '#E0E0E0',
            linkColor: '#E0E0E0',
            hideQuoteForm: false
          };
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.associationsData)) {
          this.clientData.associationsData = {
            background: "#333333",
            height: "",
            logoMaxHeight: "",
            logoMaxWidth: "200px",
            placement: "aboveFooter",
            title: '',
            subtitle: ''
          };
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.associationLogos))
          this.clientData.associationLogos = [];

        if (isNullOrUndefined(this.clientData.homePageButtonComponentData)) {
          this.clientData.homePageButtonComponentData = {
            background: "rgba(255, 255, 255, 1)",
            buttonBackground: "",
            buttonColor: "",
            height: "200px",
            buttonWidth: "55%",
            buttonFontSize: "",
            buttonPadding: "10px",
            ctaUrl: "",
            title: "Get Started",
            titleFontSize: "",
            textFontSize: "",
            color: "",
            hideContactUsButton: false,
            text: "Rent your unit today. Rent your unit today. Rent your unit today. Rent your unit today.",
            leftButtonText: "Rent Your Unit",
            rightButtonText: "Contact Us",
            leftButtonLink: "units",
            rightButtonLink: "contact"
          };
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.homePageFeaturesComponentData)) {
          this.clientData.homePageFeaturesComponentData = {
            background: "",
            circleBackground: "",
            color: "",
            featureIconBackgroundColor: "",
            featureIconColor: "",
            fontSize: "",
            showCircles: false,
            showMaterialDesignShading: false,
            showTitle: true,
            size: "55px",
            title: "Facility Features",
            subtitle: "",
            uppercase: true,
            backColor: ""
          };
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.infoBarStyleData)) {
          this.clientData.infoBarStyleData = {
            logoCenteredPhoneIcon: "https://firebasestorage.googleapis.com/v0/b/storpug-main.appspot.com/o/icons%2Fphone.png?alt=media&token=349e2fa5-cb77-4fac-9534-ffa678300d81",
            logoCenteredMapIcon: "https://firebasestorage.googleapis.com/v0/b/storpug-main.appspot.com/o/icons%2Fmap-icon.png?alt=media&token=2efd5ebd-8d13-4539-8e2c-719a98006986",
            logoHeight: "100px",
            mobileLogoHeight: "40px",
            marginTop: "25px",
            height: "150px",
            iconHeight: "35px",
            iconWidth: "50px",
            background: "rgba(255, 255, 255, 1)",
            color: "#6689FF",
            hoverColor: "#FF9800",
            mobileHeight: "100px",
            showAllLocations: true,
            logoMarginTop: "0px",
            linkIcon: "payment",
            linkText: "Login | Pay Bill",
            linkRoute: "/customer-portal/login",
            fontSize: "20px",
            hideClientEmail: true,
          };
          shouldUpdate = true;
        }

        if (isNullOrUndefined(this.clientData.infoBarStyleData.linkRoute)) {
          this.clientData.infoBarStyleData.linkRoute = '/customer-portal/login';
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.mainNavBarStyleData)) {
          this.clientData.mainNavBarStyleData = {
            showMaterialDesignShading: true,
            mattStyle: false,
            showLogo: true,
            height: "70px",
            color: "#6689FF",
            hamburgerColor: "#6689FF",
            logoHeight: "50px",
            fontSize: "16px",
            payBillColor: "#6689FF",
            payBillBackground: "#6689FF",
            payBillBorder: "#6689FF",
            payBillText: "Login | Pay Bill",
            background: "rgba(255, 255, 255, 1)",
            smHamburger: true,
            mdHamburger: false,
            activePayBillButton: false,
            showUserAccount: false,
          };
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.mainNavBarStyleData.payBillText)) {
          this.clientData.mainNavBarStyleData.payBillText = 'Login | Pay Bill';
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.mainNavBarStyleData.showUserAccount)) {
          this.clientData.mainNavBarStyleData.showUserAccount = false;
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.portableQuoteBarData)) {
          this.clientData.portableQuoteBarData = {
            title: "Instant Quote",
            background: "rgba(255, 255, 255, 1)",
            color: "#0d3c39",
            titleFontSize: "2.4em",
          };
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.separatorBarData)) {
          this.clientData.separatorBarData = {
            title: "",
            text: "",
            background: "rgba(255, 255, 255, 1)",
            color: "#0d3c39",
            titleFontSize: "2.4em",
            textFontSize: "16px",
            hideBottomTextOnMobile: false
          };
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.locationSeparatorBarData)) {
          this.clientData.locationSeparatorBarData = {
            height: "300px",
            background: "rgba(255, 255, 255, 1)",
            color: "#0d3c39",
            titleMarginTop: "10px",
            textMarginTop: "20px",
            titleFontSize: "2.4em",
            textFontSize: "16px"
          };
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.locationBannerData)) {
          this.clientData.locationBannerData = {
            height: 'auto',
            padding: '25px',
            background: '#FFFFFF',
            showSeparator: true,
            separatorColor: null,
            lineColor: null,
            color: null,
            titleColor: null,
            locationNameColor: null,
            placement: 'aboveFeatures',
            showPictures: true,
            locationBoxColor: '#fff',
            title: 'Our Locations',
            subtitle: '',
            linkToUnitsPage: false,
            showGroupBlurbs: false
          };
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.locationBannerData.locationBoxColor)) {
          this.clientData.locationBannerData.locationBoxColor = "#fff";
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.facilityInfoBannerData)) {
          this.clientData.facilityInfoBannerData = {
            height: 'auto',
            padding: '25px',
            background: '#FFFFFF',
            showAccent: 'true',
            showCta: 'true',
            color: null,
            titleColor: null,
            lineColor: null,
            layout: 'imageRight',
            breakpoint: 'cell',
            placement: 'aboveSeparator',
            onlyShowOnCorporateHome: true,
            showCard: false,
            fontSize: '',
            titleFontSize: '',
            largerImage: false
          };
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.slideshowRowData)) {
          this.clientData.slideshowRowData = {
            titleText: '',
            titleSize: '',
            titleColor: '',
            autoplaySlides: true,
            fullPageWidth: false,
            showSideArticle: false,
            sideArticleOnLeft: false,
            articleCard: true,
            slideHeight: '350px',
            backgroundColor: '',
            slideBackgroundSize: 'cover',
            articleCardBGColor: '',
            articleTextColor: '',
          };
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.howToRowData)) {
          this.clientData.howToRowData = {
            background: '',
            breakSmall: false,
            cardBackground: '',
            cardTextColor: "",
            cardTitleFontSize: '',
            cardFontSize: '',
          };
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.uhaulDealerBannerData)) {
          this.clientData.uhaulDealerBannerData = {
            height: 'auto',
            padding: '25px',
            background: '#FFFFFF',
            placement: 'aboveFooter',
            uhaulLink: null
          };
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.portalLoginData)) {
          this.clientData.portalLoginData = {
            simpleLogoUrl: "",
            backgroundImageUrl:
              "url(https://firebasestorage.googleapis.com/v0/b/fir-space-toggle.appspot.com/o/spaceToggle.jpg?alt=media&token=57103f13-c909-4687-ae80-dc6aac3378e8)",
            formBackground:
              "linear-gradient(rgba(33,33,33,.65),rgba(33,33,33,.65))",
            formColor: "#dddddd",
            existingCustomersColor: "#636973",
            existingCustomersButtonColor: "#FF9800",
            locationColor: "#636973",
            logoWidth: '130px',
            hideLogo: false,
            showChangeLocationButton: true,
          };
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.sizeGuideHeroData)) {
          this.clientData.sizeGuideHeroData = {
            useCard: false,
            cardBackground: '#FFF',
            cardBorderRadius: '0px',
            cardPadding: '34px',
            height: '200px',
            background: 'linear-gradient(rgba(0,0,0,.35),rgba(0,0,0,.35)), url(https://firebasestorage.googleapis.com/v0/b/fir-space-toggle.appspot.com/o/spaceToggle.jpg?alt=media&token=57103f13-c909-4687-ae80-dc6aac3378e8) center no-repeat',
            backgroundSize: 'cover',
            fontWeight: '700',
            color: '#fff',
            title: ''
          };
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.sizeGuideMainSectionData)) {
          this.clientData.sizeGuideMainSectionData = {
            color: '#000',
            sideButtonColor: '#000',
            sideButtonSelectedColor: '#fff',
            sideButtonSelectedBackgroundColor: '#ccc',
            fontSize: '20px',
          };
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.switchLocationComponentData)) {
          this.clientData.switchLocationComponentData = {
            imageHeight: "135px",
            titleFontSize: "",
            titleFontWeight: "",
            titleFontColor: "",
            phoneColor: "",
            phoneSize: "",
            buttonFontSize: "",
            buttonPadding: "",
            buttonMarginTop: "15%",
            buttonWidth: "100%",
            buttonColor: "",
            background: "rgba(255, 255, 255, 1)",
            buttonBackground: "",
            isClickableStates: true,
            noneSelectedImage: 'https://cdn.storagepug.com/hubfs/Blog%20Headers%20StoragePug/no-drafts@4x.png',
            noneSelectedTitle: 'Rent a unit online with ease.',
            noneSelectedText: 'Get started by selecting your state'
          };
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.switchLocationComponentData.isClickableStates)) {
          this.clientData.switchLocationComponentData.isClickableStates = true;
          this.clientData.switchLocationComponentData.noneSelectedImage = 'https://cdn.storagepug.com/hubfs/Blog%20Headers%20StoragePug/no-drafts@4x.png';
          this.clientData.switchLocationComponentData.noneSelectedTitle = 'Rent a unit online with ease.';
          this.clientData.switchLocationComponentData.noneSelectedText = 'Get started by selecting your state';
        }
        if (isNullOrUndefined(this.clientData.sizeGuideRentReserveButtonData)) {
          this.clientData.sizeGuideRentReserveButtonData = {
            padding: "9px",
            fontSize: "large",
            minWidth: "120px"
          };
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.locationBarStyleData)) {
          this.clientData.locationBarStyleData = {
            showMaterialDesignShading: true,
            showChangeLocationButton: false,
            height: "32px",
            background: "rgba(255, 255, 255, 1)",
            color: "",
            fontSize: "",
            linkColor: "",
            highlightColor: "",
            selectedLocationColor: ""
          };
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.locationBarStyleData.showChangeLocationButton)) {
          this.clientData.locationBarStyleData.showChangeLocationButton = false;
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.googleMapData)) {
          this.clientData.googleMapData = {
            mapHeight: '600px',
            showLocationName: false,
            hideEmail: false,
            zoomToLocation: true,
            useSnazzyWindows: true,
            showCloseButton: true,
            windowPlacement: 'right',
            borderRadius: '10px'
          };
          shouldUpdate = true;
        }
        if (isNullOrUndefined(this.clientData.storeLocatorData)) {
          this.clientData.storeLocatorData = {
            showCloseButton: true,
            panelMode: false,
            showSearchBarOnHomePage: false,
            autofill: true,
            windowPlacement: 'right',
            borderRadius: '10px',
            closestStoreRibbonColor: '#fff',
            closestStoreRibbonBackgroundColor: 'green',
            selectedStoreRibbonColor: '#fff',
            selectedStoreRibbonBackgroundColor: 'green',
          };
          shouldUpdate = true;
        }

        if (shouldUpdate) {
          this.updateClient();
        }
        this.goodToGo[0] = true;
        this.checkLoaded.next(true);
      });

      this.afService.loadPageSettings(this.key).subscribe(data => {
        if (isUndefined(data.$value)) {
          this.pageSettings = data;
          if (isNullOrUndefined(this.pageSettings.locationHome)) {
            this.pageSettings.locationHome = new LocationHome();
            this.afService
              .savePageSettings(this.clientData, this.pageSettings)
              .then(() => {
                this.afService.openSnackBar("Page Settings Created");
                this.goodToGo[1] = true;
                this.checkLoaded.next(true);
              })
              .catch(e => {
                this.afService.openSnackBar(e.message);
              });
          }
          else {
            this.goodToGo[1] = true;
            this.checkLoaded.next(true);
          }
        }
        else {
          this.pageSettings = new PageSettings(this.clientData.name);
          this.afService
            .savePageSettings(this.clientData, this.pageSettings)
            .then(() => {
              this.afService.openSnackBar("Page Settings Created");
              this.goodToGo[1] = true;
              this.checkLoaded.next(true);
            })
            .catch(e => {
              this.afService.openSnackBar(e.message);
            });
        }
      });

      this.afService.loadComponentSettings(this.key).subscribe(data => {
        if (isUndefined(data.$value)) {
          this.componentSettings = data;
          if (isNullOrUndefined(this.componentSettings.sliderAutoPlay)) {
            this.componentSettings.sliderAutoPlay = true;
            this.saveComponentSettings();
          }
          if (isNullOrUndefined(this.componentSettings.showSliderArrows)) {
            this.componentSettings.showSliderArrows = false;
            this.saveComponentSettings();
          }
          if (isNullOrUndefined(this.componentSettings.simpleSliderBanner)) {
            this.componentSettings.simpleSliderBanner = {
              title: 'Find your unit now',
              background: '',
              sliderFilter: 'rgba(0, 0, 0, 0.33)',
              color: '#fff',
              padding: '0',
              titleMargin: 'auto auto 0 auto',
              buttonMargin: '15px auto auto auto',
              titleFontSize: '39px',
              subtitle: 'Find your unit now',
              subtitleBackground: '',
              subtitleColor: '#fff',
              subtitlePadding: '0',
              subtitleMargin: '15px auto',
              subtitleFontSize: '28px'
            };
            this.saveComponentSettings();
          }
          this.goodToGo[2] = true;
          this.checkLoaded.next(true);
        }
        else {
          this.componentSettings = new ComponentSettings(this.clientData.name);
          this.goodToGo[2] = true;
          this.checkLoaded.next(true);
        }
      });
    });

    this.removeListener = this.renderer.listen('window', 'keydown', (event: KeyboardEvent) => {
      if (event.ctrlKey && event.keyCode === 83) {
        this.afService.updateSettingsOnServer(this.clientData);
      }
    });
  }

  ngAfterContentInit() {
    this.checkLoaded.subscribe(() => {
      console.log(this.goodToGo)
      if (this.goodToGo[0] === true && this.goodToGo[1] === true && this.goodToGo[2] === true) {
        if (this.afService.isBilly && !this.alreadyCheckBilly) {
          this.alreadyCheckBilly = true;
          setTimeout(() => {
            this.toggleOldSettings();
          });
        }
      }
    })
  }

  ngOnDestroy() {
    this.removeListener();
  }

  toggleOldSettings() {
    console.log('toggleOldSettings')
    this.styleSettings.forEach(item => {
      item.clientSettings.toggleSettings()
      item.setSettings()
    })
  }

  updateClient() {
    return this.afService.updateClient(this.clientData).then(data => {
      this.afService.openSnackBar("Data successfully saved.");
    });
  }

  savePageSettings() {
    this.afService
      .savePageSettings(this.clientData, this.pageSettings)
      .then(() => {
        this.afService.openSnackBar("Page Settings Updated Successfully");
      })
      .catch(e => {
        this.afService.openSnackBar(e.message);
      });
  }

  saveComponentSettings(event?) {
    if (event) {
      // this only happens for the slideshow
      this.componentSettings.sliderUrls = event;
    }
    return this.afService
      .saveComponentSettings(this.clientData, this.componentSettings)
      .then(data => {
        console.log();
        this.afService.openSnackBar("Component Settings Updated.");
      })
      .catch(e => {
        this.afService.openSnackBar(e.message);
      });
  }

  removeSlider(index) {
    this.componentSettings.sliderUrls.splice(index, 1);
  }

  addSlider() {
    if (typeof this.componentSettings.sliderUrls === "undefined")
      this.componentSettings.sliderUrls = new Array<string>();
    this.componentSettings.sliderUrls.push(null);
  }

  async copyAboutHeroStyles() {
    try {
      const confirm = await swal({
        title: "Are you sure?",
        text: "This will replace anything currently there.",
        icon: "warning",
        buttons: true,
        dangerMode: true
      });
      if (confirm) {
        const objectNames = [
          'sizeGuideHeroData',
          'contactHeaderData',
          'viewAllReviewsHeaderData',
          'storageTipsHeaderData',
          'faqsHeaderData',
          'storageCalculatorHeaderData',
          'generalInfoHeaderData',
          'storeLocatorHeaderData',
          'customPageHeroData',
        ];
        let errors = [];

        for (let name of objectNames) {
          try {
            this.clientData[name].background = this.clientData.aboutUsHeroData.background;
            this.clientData[name].backgroundSize = this.clientData.aboutUsHeroData.backgroundSize;
            this.clientData[name].cardBackground = this.clientData.aboutUsHeroData.cardBackground;
            this.clientData[name].cardBorderRadius = this.clientData.aboutUsHeroData.cardBorderRadius;
            this.clientData[name].cardPadding = this.clientData.aboutUsHeroData.cardPadding;
            this.clientData[name].color = this.clientData.aboutUsHeroData.color;
            this.clientData[name].fontWeight = this.clientData.aboutUsHeroData.fontWeight;
            this.clientData[name].height = this.clientData.aboutUsHeroData.height;
            this.clientData[name].useCard = this.clientData.aboutUsHeroData.useCard;
          }
          catch (error) {
            errors.push(name);
            console.warn(`style change error for ${ name } caught:`, error);
          }
        }

        await this.updateClient();
        if (errors.length > 0) {
          this.afService.openSnackBar(`Error updating the following headers: ${ errors.join(', ') }`)
        }
      }
    }
    catch (error) {
      console.warn('swal error caught:', error);
    }
  }

  saveMdToggle(event: MdSlideToggleChange, key) {
    this.componentSettings[key] = event.checked;
    this.saveComponentSettings();
  }

  saveSetHeightToScreen(event: MdSlideToggleChange) {
    this.componentSettings.simpleSliderBanner.setHeightToScreen = event.checked;
    this.saveComponentSettings();
  }

  removeAssociationLink(index: number) {
    this.clientData.associationLogos.splice(index, 1);
    this.updateClient();
  }

  goBack() {
    this.router.navigate(['../../'], { relativeTo: this.route });
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/component-structure-settings/component-structure-settings.component.ts